import { useRef, useMemo } from 'react';

import { usePricingExperiments } from '~shared/hooks/usePricingExperiments';
import { PricingExperiments } from '~shared/types/pricing/experiments';

import ACTIVE_TREATMENTS from './treatments';

import { ExperimentTreatment } from './types';

/**
 * This hook returns an object containing active experiment components
 * intended for full component swaps within a page or an entire page component itself
 * There can be multiple active experiments at once but only one treatment name and component per experiment
 * @returns ExperimentTreatment
 */

export default function useTreatment(conditions = true): ExperimentTreatment {
  const assignments = usePricingExperiments();
  const treatments = useRef<ExperimentTreatment>({
    priceExperiment: {},
    uiExperiment: {},
    featureExperiment: {},
  });
  useMemo(() => {
    Object.keys(assignments).forEach(assignment => {
      const exp = assignments[assignment as keyof PricingExperiments];

      if (exp.hasAssignment && exp.treatmentName in ACTIVE_TREATMENTS && conditions) {
        const { configExperimentIdentifier, experimentComponent } = ACTIVE_TREATMENTS[exp.treatmentName];
        treatments.current = {
          ...treatments.current,
          [assignment]: {
            configExperimentIdentifier,
            experimentComponent,
          },
        };
      }
    });
  }, [assignments, treatments, conditions]);
  return treatments.current;
}
